import useClient from "@/api/client";
import useGet from "@/composables/useGet";
import { useValidation } from "@/composables/useValidation";
import { computed, ref } from "vue";
import { z } from "zod";
import { ZAuftrag } from "./useAbrechnungsplan";

const ZOutput = z.object({
  auftrag: ZAuftrag,
});

export type IAuftrag = z.infer<typeof ZAuftrag>;
export type IOutput = z.infer<typeof ZOutput>;

const useAuftrag = (id: string) => {
  const client = useClient();
  const data = ref<IOutput>();

  const { request, urlParams } = client.get("/query/abrechnung_auftrag/{}/");
  urlParams.value = id;
  const query = useGet(request, data);

  useValidation(data, ZOutput.optional());

  const auftrag = computed(() => data.value?.auftrag);

  return {
    query,
    auftrag,
  };
};

export default useAuftrag;
